export const API_URL = (alias = '') => {
    return `${process.env['VUE_APP_API_URL']}${alias}`
}

// export const updateToken()